<template>
  <div>
    <ith-grid-big-skeleton v-show="moviesMustWatch == null" />
    <div v-show="moviesMustWatch == ''">
      <ith-no-results />
    </div>
    <div class="movie">
      <template v-for="item in moviesMustWatch">
        <router-link
          :key="item.id"
          :to="`/detail/${item.show.id}/${item.show.slug}`"
          class="style-none"
        >
          <div class="movie--item" @click="goToShow(item)">
            <figure class="movie-img">
              <div v-lazy-container="{ selector: 'img' }">
                <img
                  v-if="item.show.imageUrl != null"
                  class="movie-img"
                  :data-src="item.show.imageUrl"
                  :alt="item.show.title"
                />
                <img v-else class="movie-no-img" data-src="/img/no_image.png" />
              </div>
            </figure>
            <div class="movie-detail">
              <span class="movie-detail--order">{{ item.order }}</span>
              <div class="movie-detail--title">
                {{ item.show.title }}
                <div class="movie-detail--imdb">
                  <!-- <font-awesome-icon color="#ffffff" :icon="['fab', 'imdb']" /> -->
                  <img
                    class="icon--imdb"
                    src="../../assets/imdb.png"
                    alt="IMDB logo"
                  />
                  <span class="rating--imdb">{{ item.show.imdbRating }}</span>
                </div>
              </div>
              <div>
                {{ item.show.description | truncate_200 }}

                <strong class="movie-detail--view-more">View More</strong>
              </div>
              <div class="movie-detail--icon">
                <button
                  @click.prevent="setWatchlist(item.show)"
                  class="movie-detail--icon--button"
                  :class="{
                    active: item.show.watchlist,
                    backgroundActive: item.show.watchlist,
                  }"
                >
                  <font-awesome-icon v-if="item.show.watchlist" icon="check" />
                  <font-awesome-icon v-else icon="plus-circle" />
                </button>

                <button
                  @click.prevent="setWatched(item.show)"
                  class="movie-detail--icon--button"
                  :class="{
                    active: item.show.watched,
                    backgroundActive: item.show.watched,
                  }"
                >
                  <font-awesome-icon icon="eye" />
                </button>
              </div>
            </div>
          </div>
        </router-link>
      </template>
    </div>
    <ith-pagination-bullets
      :items="totalPagesMust"
      :pagination="paramsMust.page"
      :k="key"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    key: "MustWatched",
  }),

  computed: mapState([
    "moviesMustWatch",
    "items_user",
    "totalPagesMust",
    "paramsMust",
    "user",
  ]),

  mounted() {
    this.$store.dispatch("FETCH_MUSTWATCHED");
  },
  watch: {
    "items_user.mustwatched": function () {
      this.$store.dispatch("FETCH_MUSTWATCHED");
    },
  },
  methods: {
    async setWatched(item) {
      await this.$store.commit("EDIT_MUST_WATCHED_SHOW", item);
      const index = this.moviesMustWatch.findIndex(
        (element) => element.show.id === item.id
      );
      this.$store.dispatch("SET_WATCHED", this.moviesMustWatch[index].show);
    },
    async setWatchlist(item) {
      await this.$store.commit("EDIT_MUST_WATCHLIST_SHOW", item);
      const index = this.moviesMustWatch.findIndex(
        (element) => element.show.id === item.id
      );
      this.$store.dispatch("SET_WATCHLIST", this.moviesMustWatch[index].show);
    },

    goToShow(item) {
      this.$store.commit("EDIT_SHOW", item);
    },
    getMovies() {},
  },
};
</script>

<style scoped>
.movie {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-evenly;
  column-gap: 15px;
}
.movie--item {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  height: 340px;
  background-color: #375072;
  border-radius: 10px;
  cursor: pointer;
}

.movie-img {
  margin: 0;
  background-color: #d5d5d5;
  border-radius: 10px 0 0 10px;
  width: 100%;
  height: 340px;
  object-fit: cover;
}

.movie-detail {
  font-size: 0.75rem;
  border-radius: 10px;
  color: white;
  display: grid;
  height: 100%;
  grid-template-columns: 100%;
  align-content: space-around;
  padding: 0px 10px;
  position: relative;
}

.movie-no-img {
  margin: 0;
  border-radius: 10px;
  width: 70%;
  object-fit: contain;
  margin: 20% 15%;
}

.movie-detail > p,
.movie-detail > div {
  margin-top: 2px;
}

.movie-detail--title {
  padding-top: 7px;
  font-size: 1.4em;
  font-weight: 600;
}
.movie-detail--imdb {
  display: flex;
  column-gap: 10px;
  font-size: 0.75rem;
  font-weight: 400;
  margin-top: 4px;
}
.icon--imdb {
  width: 27px;
  height: 14px;
}

.movie-detail--icon {
  display: flex;
  column-gap: 10px;
  justify-content: flex-end;
  z-index: 1000;
}
/* .movie-detail--icon>p {
  display: flex;
  column-gap: 10px;
} */
.movie-detail--icon--button {
  height: 27x;
  width: 27px;
  border: 0px;
  border-radius: 6px;
  background-color: #284367;
  color: #939292;
  padding: 5px;
  font-size: 1.2em;
  justify-self: center;
  cursor: pointer;
}

.active {
  color: white !important;
}
.movie-detail--order {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0px 10px 0px 10px;
  background-color: #94c659;
  color: white;
  width: 40px;
  height: 22px;
  font-size: 1.3em;
  padding-top: 3px;
  font-weight: 600;
  text-align: center;
}
.rating--imdb {
  margin-left: 10px;
}
.backgroundActive {
  background-color: #94c659;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1050px) and (max-width: 1264px) {
  .movie {
    grid-template-columns: repeat(3, auto);
    justify-content: space-evenly;
    column-gap: 12px;
  }
}
@media (min-width: 960px) and (max-width: 1050px) {
  .movie {
    grid-template-columns: repeat(2, auto);
    justify-content: space-evenly;
    column-gap: 15px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .movie {
    grid-template-columns: repeat(2, auto);
    justify-content: space-evenly;
    column-gap: 15px;
  }
}

@media (max-width: 600px) {
  .movie {
    grid-template-columns: repeat(1, auto);
    justify-content: space-around;
    column-gap: 0px;
  }
  .movie--item {
    width: 95%;
    height: 330px;
    margin-left: 2.5%;
    justify-self: space-around;
  }
  .movie-img {
    height: 330px;
  }
}
</style>
